import React from 'react';
import Confetti from 'react-confetti';

function ConfettiOverlay({ show, width, height, opacity = 1 }) {
  if (!show) return null;
  return (
    <Confetti
      width={width}
      height={height}
      recycle={false}
      numberOfPieces={500}
      gravity={0.3}
      run={show}
      wind={0.05}
      style={{ position: 'fixed', opacity, transition: 'opacity 0.1s linear', pointerEvents: 'none' }}
    />
  );
}

export default ConfettiOverlay;


